import { CatalogProductCardLoadingProps } from './models';

export function CatalogProductCardLoading({ className, count = 4, isCompact = false }: CatalogProductCardLoadingProps) {
    return Array(count)
        .fill('')
        .map((_, i) => (
            <div
                key={i}
                className={`h-full overflow-hidden rounded-2xl border border-solid border-N200 bg-white shadow-elevation1 ${className ?? ''}`}>
                {/* Mobile skeleton */}
                <div className='flex min-h-[148px] flex-col gap-2 p-3 md:hidden'>
                    <div className='flex gap-3'>
                        <div className='h-16 w-16 shrink-0 animate-pulse rounded-xl bg-sky-50' />
                        <div className='flex min-w-0 flex-1 flex-col justify-center gap-2'>
                            <div className='h-3 w-16 animate-pulse rounded bg-N100' />
                            <div className='h-8 w-full animate-pulse rounded bg-N100' />
                            <div className='h-3 w-2/3 animate-pulse rounded bg-N100' />
                        </div>
                    </div>
                    <div className='flex items-center justify-between border-0 border-t border-solid border-N100 pt-2.5'>
                        <div className='space-y-1'>
                            <div className='h-5 w-28 animate-pulse rounded bg-N100' />
                            <div className='h-4 w-32 animate-pulse rounded bg-N100' />
                        </div>
                        <div className='h-8 w-20 animate-pulse rounded-lg bg-N100' />
                    </div>
                </div>

                {/* Desktop skeleton */}
                <div className='hidden h-full flex-col md:flex'>
                    <div className={`${isCompact ? 'h-48' : 'h-64'} shrink-0 animate-pulse bg-sky-50`} />
                    <div className='flex flex-1 flex-col gap-2 px-4 pb-3 pt-1'>
                        <div className='h-4 w-16 animate-pulse rounded bg-N100' />
                        <div className='h-10 w-full animate-pulse rounded bg-N100' />
                        <div className={`flex flex-wrap gap-1 ${isCompact ? '' : 'min-h-[3.25rem]'}`}>
                            <div className='h-5 w-16 animate-pulse rounded-md bg-N100' />
                            <div className='h-5 w-20 animate-pulse rounded-md bg-N100' />
                        </div>
                    </div>
                    <div className='mt-auto flex items-center justify-between border-t border-N100 bg-N50/70 px-4 py-3'>
                        <div className='space-y-1'>
                            <div className='h-6 w-28 animate-pulse rounded bg-N100' />
                            <div className='h-5 w-32 animate-pulse rounded bg-N100' />
                        </div>
                        <div className='h-8 w-20 animate-pulse rounded-lg bg-N100' />
                    </div>
                </div>
            </div>
        ));
}
